<template>
<body class="tab-11">
  <!-- header for tv START -->
  <div class="header header-tv" v-on="countDownTimer()">

    <!-- col-1 start -->
    <div class="col-1">

    <!-- start logo tv -->
      <div class="leftcol-banner logoTv">

        <!-- leftcol-banner start -->
        <div class="leftcol-banner">

          <div class="leaguetv" v-if="$store.state.game">
            <div>{{$t('league')}}</div>
            <div>{{$store.state.game.League}}</div>
          </div>

          <div class="weektv" v-if="$store.state.game">
            <div>{{$t('week')}}</div>
            <div>{{$store.state.game.Week}}</div>
          </div>

        </div>
        <!-- leftcol-banner stop -->

      </div>
    <!-- stop logo tv -->

    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2"></div>
    <!-- col-2 stop -->

    <!-- col-1 start -->
    <div class="col-1">
      <div class="start">{{$t('event')}}</div>
    </div>
    <!-- col-1 stop -->

  </div>
  <!-- header for tv STOP -->

  <!-- main START -->
  <div class="main">
    <div class="tab11-main">
      <div id="animation_container">
        <canvas id="canvas" width="auto" height="600" style="display: block; background-color: transparent;"></canvas>
        <div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:auto; height:600px; left: 0px; top: 0px; display: block;">
        </div>
      </div>
    </div>
  </div>
  <!-- main STOP -->
  
</body>
</template>

<script>
var canvas, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
function init() {
  canvas = document.getElementById("canvas");
  anim_container = document.getElementById("animation_container");
  dom_overlay_container = document.getElementById("dom_overlay_container");
  var comp=AdobeAn.getComposition("9F6BB161710E06438CF19C51C4D73821");
  var lib=comp.getLibrary();
  handleComplete({},comp);
}
function handleComplete(evt,comp) {
  //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
  var lib=comp.getLibrary();
  var ss=comp.getSpriteSheet();
  exportRoot = new lib.Score();
  window.stage = new lib.Stage(canvas);  
  //Registers the "tick" event listener.
  fnStartAnimation = function() {
    window.stage.addChild(exportRoot);
    createjs.Ticker.framerate = lib.properties.fps;
    createjs.Ticker.addEventListener("tick", stage);
  }     
  //Code to support hidpi screens and responsive scaling.
  AdobeAn.makeResponsive(true,'both',true,1,[canvas,anim_container,dom_overlay_container]); 
  AdobeAn.compositionLoaded(lib.properties.id);
  fnStartAnimation();
}

export default {
  name: 'Jackpot',
  timer: 0,
  created: function () {
    this.$store.dispatch('apirequest', {name: "game/"});
  },
  props: ['league', 'week'],
  computed: {
    game: function(){
      let game = { count: 3};
      return game;
    }
  },
  mounted() {
    init()
  },  
  destroyed() {
      clearInterval(this.$options.timer);
    },
  methods: {
    countDownTimer() {
      let count= 0;
      if(!this.$options.timer){
        this.$options.timer = setInterval(() => {
          if(this.game.count <= 0){
            this.$router.push({name: 'TV2'});
          }
            this.game.count -= 1
        }, 1000)
      }
    }, 
  }
};
</script>

<style scoped>
  .main {
    background-color: #FEFAD4;
    height: calc(100vh - 12vmin);
    overflow: hidden;
  }
  #animation_container {
    /*
    position:absolute;
    margin:auto;
    left:0;right:0;
    top:0;bottom:0;
    */
    background-color: transparent; 
    width:auto;
    margin: 0 auto;
    position: relative;
    top: 14vmin;
  }
  .tab11-main {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin: 0 auto;
  }
</style>